module.exports = __webpack_public_path__ + "297b997fd4f7c2674a7afdd09e1162f9.pdf";